<p>
	As far as I know, our country has not yet formally acknowledged the existential risk of AI.
	Without that acknowledgement, it is unlikely that we will be able to take the necessary steps to
	mitigate this risk. I would like to ask you to consider proposing a motion to acknowledge the
	existential risk of AI.
</p>
